(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const shortScreen = matchMedia('(max-height: 650px)');
  let roots = [], queued = false;
  const bounded = n => Math.min(1, Math.max(0, n));
  function select(root, index) {
    root.querySelectorAll('[data-lt-card]').forEach((card, n) => {
      card.classList.toggle('is-active', n === index);
      const hidden = root.classList.contains('lt-motion') && !mobile.matches && n !== index;
      if (hidden) card.setAttribute('aria-hidden', 'true'); else card.removeAttribute('aria-hidden');
      if (card.matches('a[href]')) card.tabIndex = hidden ? -1 : 0;
    });
    root.querySelectorAll('[data-lt-scene]').forEach((button, n) => button.setAttribute('aria-pressed', String(n === index)));
    const step = root.querySelector('[data-lt-step]');
    if (step) step.textContent = String(index + 1).padStart(2, '0');
  }
  function draw() {
    queued = false;
    const header = document.querySelector('sticky-header, .pv-header');
    const top = header ? Math.round(header.getBoundingClientRect().height) : 80;
    for (const root of roots) {
      const active = root.dataset.motion === 'true' && !reduce.matches && !shortScreen.matches;
      root.classList.toggle('lt-motion', active);
      root.style.setProperty('--lt-sticky-top', `${top}px`);
      const journey = root.querySelector('[data-lt-journey]');
      if (!journey) continue;
      const box = journey.getBoundingClientRect();
      const pinHeight = Math.max(1, innerHeight - top);
      const p = bounded((top - box.top) / Math.max(1, box.height - pinHeight));
      root.style.setProperty('--lt-progress', p);
      if (active && !mobile.matches) select(root, Math.min(2, Math.floor(p * 3)));
      else {
        const rail = root.querySelector('.lt-journey-art');
        const cards = [...root.querySelectorAll('[data-lt-card]')];
        const closest = cards.reduce((best, card, n) => Math.abs(card.offsetLeft - rail.scrollLeft - cards[0].offsetLeft) < best.distance ? {n, distance: Math.abs(card.offsetLeft - rail.scrollLeft - cards[0].offsetLeft)} : best, {n:0,distance:Infinity});
        select(root, closest.n);
      }
      const hero = root.querySelector('.lt-hero');
      const hp = bounded(-hero.getBoundingClientRect().top / hero.offsetHeight);
      root.style.setProperty('--lt-hero-shift', active ? `${hp * 38}px` : '0px');
    }
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(draw); } }
  function init() {
    roots = [...document.querySelectorAll('[data-lt-world]')];
    roots.forEach(root => {
      if (root.dataset.ltBound) return;
      root.dataset.ltBound = 'true';
      root.querySelector('.lt-journey-art')?.addEventListener('scroll', schedule, {passive:true});
      root.querySelectorAll('[data-lt-scene]').forEach(button => button.addEventListener('click', () => {
        const index = Number(button.dataset.ltScene);
        if (root.classList.contains('lt-motion') && !mobile.matches) {
          const journey = root.querySelector('[data-lt-journey]');
          const top = parseFloat(root.style.getPropertyValue('--lt-sticky-top')) || 80;
          const distance = journey.offsetHeight - (innerHeight - top);
          const absolute = journey.getBoundingClientRect().top + scrollY;
          scrollTo({top:absolute - top + distance * ((index + .5) / 3),behavior:'smooth'});
        } else {
          const rail = root.querySelector('.lt-journey-art');
          const cards = root.querySelectorAll('[data-lt-card]');
          rail.scrollTo({left:cards[index].offsetLeft - cards[0].offsetLeft,behavior:reduce.matches ? 'instant' : 'smooth'});
        }
      }));
    });
    draw();
  }
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  reduce.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
